import { LoadingButton } from "@mui/lab";
import {
    Alert,
    Button,
    Container,
    Divider,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    PollDetailDto,
    PollQuestionDto,
    PollQuestionOptionDto,
    PollService,
} from "../../../api/psc";
import { PageHeader, Spinner } from "../../../components/exports";
import Question from "../components/Question";

export default function PollDetail() {
    let { id: hashId } = useParams();

    const navigate = useNavigate();

    const [poll, setPoll] = useState<PollDetailDto | null>(null);
    const [success, setSuccess] = useState<boolean>(false);
    const [answer, setAnswer] = useState<{ [id: number]: number }>({});
    const [requestInProgress, setRequestInProgress] = useState(false);

    useEffect(() => {
        PollService.getPollDetail(hashId, "1").then((r) => {
            setPoll(r);
        });
    }, [hashId]);

    const handleSelection = (
        question: PollQuestionDto,
        option: PollQuestionOptionDto
    ) => {
        const updatedAnswer = { ...answer };
        updatedAnswer[question.id] = option.id;
        setAnswer(updatedAnswer);
    };

    const uploadAnswer = () => {
        setRequestInProgress(true);
        PollService.answerPoll(hashId, "1", {
            selectedOptions: Object.values(answer),
        }).then((r) => {
            setSuccess(true);
            setRequestInProgress(false);
        });
    };

    const goHome = () => {
        navigate("/");
    };

    if (!poll) {
        return <Spinner />;
    }

    if (success) {
        return (
            <Container maxWidth="sm">
                <PageHeader title="نظرسنجی" />
                <Stack spacing={2}>
                    <Alert severity="success">
                        پاسخ های شما ثبت شد با تشکر
                    </Alert>

                    <Button onClick={goHome}>بازگشت به صفحه اصلی</Button>
                </Stack>
            </Container>
        );
    }

    const areAllQuestionsAnswered =
        Object.keys(answer).length === poll.questions.length;

    return (
        <Container maxWidth="sm">
            <PageHeader title="نظرسنجی" />

            <Stack spacing={2}>
                <Paper sx={{ p: 1.5 }}>
                    <Stack spacing={1}>
                        <Typography color="primary">{poll.title}</Typography>

                        <Typography color="text.secondary">
                            {poll.description}
                        </Typography>
                    </Stack>
                </Paper>

                <Typography>سوالات</Typography>

                <Divider />

                {poll.questions.map((q) => {
                    const selectedOption = answer[q.id];
                    return (
                        <Question
                            key={q.id}
                            question={q}
                            selectOption={handleSelection}
                            selectedOption={selectedOption}
                        />
                    );
                })}

                {!areAllQuestionsAnswered && (
                    <Alert severity="warning">
                        لطفا به تمامی سوالات پاسخ دهید
                    </Alert>
                )}

                <LoadingButton
                    variant="contained"
                    color="secondary"
                    onClick={uploadAnswer}
                    disabled={!areAllQuestionsAnswered}
                    loading={requestInProgress}
                >
                    پاسخ دهی به نظرسنجی
                </LoadingButton>
            </Stack>
        </Container>
    );
}
